// extracted by mini-css-extract-plugin
export var screen = "feed-module--screen--5D1JG";
export var header = "feed-module--header--BYpU3";
export var headerContent = "feed-module--headerContent--Jq0kp";
export var headerUsername = "feed-module--headerUsername--EjTAv";
export var headerDesc = "feed-module--headerDesc--rWNE+";
export var headerAvatar = "feed-module--headerAvatar--pWqdd";
export var icon = "feed-module--icon--Vx6se";
export var postItem = "feed-module--postItem--xyhUL";
export var postSide = "feed-module--postSide--2gd5m";
export var link = "feed-module--link--gJPtV";
export var vertLine = "feed-module--vertLine--lx1xo";
export var postIcon = "feed-module--postIcon--u-7LX";
export var postContent = "feed-module--postContent--VGbPi";
export var postHeader = "feed-module--postHeader--p+RVG";
export var postTitle = "feed-module--postTitle--5d6mC";
export var postDate = "feed-module--postDate--aY0Gz";
export var postBody = "feed-module--postBody--PZTY6";
export var footer = "feed-module--footer--BJUGj";
export var dateDivider = "feed-module--dateDivider--u0zbK";
export var month = "feed-module--month--T3CA-";
export var linkPreview = "feed-module--linkPreview--wiHOD";
export var linkImage = "feed-module--linkImage--BmrS5";